import axios from 'axios';

const safePathname = (rawUrl, baseUrl) => {
    if (!rawUrl) return undefined;
    try {
        return new URL(rawUrl, baseUrl || 'http://placeholder').pathname;
    } catch {
        return rawUrl.split(/[?#]/)[0];
    }
};

export const enrichAxiosError = (error) => {
    const method = error?.config?.method;
    const url = safePathname(error?.config?.url, error?.config?.baseURL);
    const status = error?.response?.status;

    // eslint-disable-next-line no-param-reassign
    error.sentryContext = {
        tags: {
            'http.method': method,
            'http.url': url,
            'http.status': status,
        },
        fingerprint: ['{{ default }}', method, url, status].filter(
            (v) => v !== undefined && v !== null,
        ),
    };

    return Promise.reject(error);
};

const axiosInstance = axios.create({
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    },
});

axiosInstance.interceptors.response.use(
    (response) => response,
    enrichAxiosError,
);

export default axiosInstance;
